import { isDefined, isEmpty } from '@hsp/utilities';

import { paths } from 'constants/paths';
import { PathKeys } from 'types/constants/path.type';

export const buildUrl = (key: PathKeys | PathKeys[]): string => {
  if (!Array.isArray(key)) {
    key = [key];
  }

  const pathValues = key.reduce((concatenatedValue: Set<string>, currentKey: PathKeys) => {
    // reason: trouble determining what the type of previousValue should be, in this case
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const pathValue = currentKey.split('.').reduce((previousValue: any, currentValue) => {
      if (isEmpty(previousValue)) {
        return '';
      } else {
        const current = previousValue[currentValue];

        if (!isDefined(current)) {
          return '';
        }

        if (typeof current === 'string') {
          return current;
        }

        if (typeof current === 'object') {
          if ('path' in current) {
            concatenatedValue.add(current.path);
          }
        }

        return isEmpty(current) ? '' : current;
      }
    }, paths);

    concatenatedValue.add(pathValue);

    return concatenatedValue;
  }, new Set<string>());

  return [...pathValues].join('/').replace(/\/\//, '/');
};
